//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
	props:{
		addressList:{
			type:Array,
			default(){
				return []
			}
		}
	},
	data() {
		return {
			source: 0,
			point:require('static/specialty/point.png'),
			pointa:require('static/specialty/pointa.png'),
			choseIndex:0
		}
	},
	mounted() {
		// this.getList()
	},
	methods:{			
		choseAddress(item,index){
			this.choseIndex=index
			item.address=item.provinceName + item.cityName + item.districtName + item.detailAddress;
			this.$emit('choseAddress',item)
			this.$emit('hide')
		},
		addAddress(){
			this.$emit('upShowName','info')
		},
		editAddress(item){
			this.$emit('editAddress',item)
		}
	}
}
